import React, { useEffect, useState } from 'react';
import { ReactComponent as HouseWithMagnifierIcon } from '../../../../../../../../resource/HouseWithMagnifier.svg';
import TenantsWithCommentBlock from '../../../../../../components/ui/TenantsWithCommentBlock/TenantsWithCommentBlock';
import DottedBorderBackground from '../../../../../../components/common/DottedBorderBackground/DottedBorderBackground';
import AddAndInfoButtons from '../../../../../../components/ui/AddAndInfoButtons/AddAndInfoButtons';
import useChangeModalVisible from '../../../../../../../../hooks/useChangeModalVisible';
import AddTenantModal from '../../../../../../components/ui/modals/AddTenantModal/AddTenantModal';
import { texts } from '../../../../../../constants/texts';
import useCurrentAddress from '../../../../../../hooks/useCurrentAddress';
import useFlatsGridState from '../../../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../../../hooks/useHousingStockState';
import { addressStagesColorsMap } from '../../../../../../constants/stagesColorMaps';
import { withAddAndInfo } from '../../hocs/withAddAndInfo';
import styles from './ChessView.module.scss';
import RequestsBlock from '../RequestsBlock/RequestsBlock';
import { chessViewMode } from '../../../../../../constants/chessViewMode';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';

const generateTitle = (flat) => {
  const { porch, address } = flat;
  const { name, typeName, synonym } = address || {};

  const porchBlock = porch ? `${porch} подъезд` : '';
  const typeNameText = typeName?.trim()?.toLowerCase() || '';
  const nameText = name?.trim() || '';
  const additionalInfoText = synonym?.trim() ? `(${synonym.trim()})` : '';

  const roomBlock = [nameText, typeNameText, additionalInfoText]
    .filter((text) => text?.trim())
    .join(' ');

  return [porchBlock, roomBlock].filter((text) => text?.trim()).join(', ');
};

const AddAndInfoActions = withAddAndInfo({ Component: AddAndInfoButtons });

const ExpandedContent = ({ flatData }) => {
  const [currentTenant, setCurrentTenant] = useState(null);

  const chessViewColorMode = useSelector(
    (state) => state.housingStockStore.chessViewColorMode
  );

  const address = useCurrentAddress();

  const {
    visible: addTenantModalVisible,
    showModal: showAddTenantModal,
    hideModal: hideAddTenantModal,
  } = useChangeModalVisible();

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const handleChangeButtonClick = (tenant) => {
    showAddTenantModal();
    setCurrentTenant(tenant);
  };

  const handleCancel = () => {
    setCurrentTenant(null);
    hideAddTenantModal();
  };

  useEffect(() => {
    setCurrentTenant((prev) => {
      if (prev) {
        return (
          flatData?.clients.find((client) => client.id === prev.id) || null
        );
      }

      return prev;
    });
  }, [flatData]);

  return (
    <div className={styles.contentRoot}>
      <div className={styles.contentHeader}>
        <DottedBorderBackground className={styles.contentTitleWrap}>
          <HouseWithMagnifierIcon className={styles.contentIcon} />
          <p className={styles.contentTitle}>{generateTitle(flatData)}</p>
        </DottedBorderBackground>
        {Boolean(flatData.addressLifeCycle?.stageAddressLifeCycle?.name) && (
          <DottedBorderBackground
            style={{
              fontWeight: 700,
              color: '#000',
              backgroundColor:
                addressStagesColorsMap.get(flatData.stageId) || '#fff',
            }}
          >
            {flatData.addressLifeCycle?.stageAddressLifeCycle?.name}
          </DottedBorderBackground>
        )}
        {flatData?.address?.addressTypeFinishName &&
          chessViewColorMode === chessViewMode.applicationMonitoring && (
            <Tooltip title="Вид отделки">
              <DottedBorderBackground
                style={{
                  fontWeight: 700,
                  color: '#000',
                }}
              >
                {flatData?.address?.addressTypeFinishName}
              </DottedBorderBackground>
            </Tooltip>
          )}

        {chessViewColorMode !== chessViewMode.applicationMonitoring && (
          <AddAndInfoActions
            className={styles.addAndInfoBtns}
            room={flatData}
          />
        )}
      </div>
      {chessViewColorMode === chessViewMode.applicationMonitoring ? (
        <RequestsBlock addressId={flatData.addressId} />
      ) : (
        <>
          <TenantsWithCommentBlock
            tenants={flatData.clients}
            onChangeButtonClick={handleChangeButtonClick}
            changeButtonText={`${texts.edit}/${texts.delete}`}
            addressId={flatData.addressId}
          />
          <AddTenantModal
            visible={addTenantModalVisible}
            onCancel={handleCancel}
            address={address}
            addressId={flatData.addressId}
            initialValues={currentTenant}
            queryKeys={[flatsGridQueryKey, housingStockQueryKey]}
          />
        </>
      )}
    </div>
  );
};

export default ExpandedContent;
